<template>
    <div>
        <SubscriptionAlert origin="modal" @close="showModalSubscription = $event" :show="showModalSubscription" plan />
        <Desktop
            :canBuyQuotationCreditCard="canBuyQuotationCreditCard"
            :bonus="bonus"
            :coins="coins"
            :plan-type="planType"
            :supplier-name="supplierName"
            :use-credit-card-countdown="useCreditCardCountdown"
            :userNotification="count"
            @push-route="pushRoute"
            @logout="logoutWithRedirect"
            @openSubscriptionAlertModal="openSubscriptionAlertModal"
            @showModal="openModal"
            @set-supplier="setSupplier"
            v-if="!isMobile"
        />
        <Mobile
            :canBuyQuotationCreditCard="canBuyQuotationCreditCard"
            :bonus="bonus"
            :coins="coins"
            :plan-type="planType"
            :supplier-name="supplierName"
            :use-credit-card-countdown="useCreditCardCountdown"
            :show="show"
            :userNotification="count"
            @show="showAction"
            @push-route="pushRoute"
            @logout="logoutWithRedirect"
            @openSubscriptionAlertModal="openSubscriptionAlertModal"
            @showModal="openModal"
            @set-supplier="setSupplier"
            v-else
        />
        <NotificationsModal
            :showModal="showModal"
            @closeModal="closeModal"
            :notifications="notifications"
            @nextPage="nextPage"
        />
    </div>
</template>

<script>
import { getSupplier } from '@/services';
import { getAllNotifications, setNotificationsRead } from '@/services/api/notifications';
import NotificationsModal from '@/components/modal/notifications-modal';
import Desktop from '@/layouts/header/supplier/desktop';
import Mobile from '@/layouts/header/supplier/mobile';
import SubscriptionAlert from '@/components/modal/subscription-alert/';
// Requisições
import { mapActions, mapState } from 'vuex';
export default {
    name: 'header-supplier',
    components: { Desktop, Mobile, SubscriptionAlert, NotificationsModal },
    data: () => ({
        isMobile: '',
        show: false,
        showModalSubscription: false,
        showModal: false,
        notifications: [],
        urlCredito: `${process.env.VUE_APP_DOMAIN_BASE_URL}credito`,
    }),
    methods: {
        ...mapActions('user', ['logout', 'setSubscriptionHeader', 'setCountNotificationUnread']),
        showAction() {
            this.show = !this.show;
            this.$emit('show', this.show);
        },
        logoutWithRedirect() {
            this.logout();
            this.$router.push({ name: 'LandingPage' });
        },
        pushRoute(objectUrl) {
            if (objectUrl.solo) {
                window.open(objectUrl.url, '_blank');
            } else if (objectUrl.url && this.$route.name != objectUrl.url) {
                const router = { name: objectUrl.url };
                if (objectUrl.query) router.query = objectUrl.query;
                this.$router.push(router);
            }
        },
        openSubscriptionAlertModal() {
            this.showModalSubscription = true;
        },
        async openModal() {
            try {
                const data = await getAllNotifications('');
                this.notifications = data;
            } catch (e) {
                console.error(e);
            } finally {
                this.showModal = true;
            }
        },
        async closeModal() {
            try {
                this.showModal = false;
                await setNotificationsRead();
            } catch (e) {
                console.error(e);
            } finally {
                this.setCountNotificationUnread();
            }
        },
        async nextPage(next) {
            const data = await getAllNotifications(`?page=${next}`);
            this.notifications.results.push(...data.results);
            this.notifications.count = data.count;
            this.notifications.next = data.next;
            this.notifications.previous = data.previous;
        },
        async setSupplier() {
            const data = await getSupplier();
            this.pushRoute({
                url: `${this.urlCredito}?name=${data[0].name}&email=${data[0].supplierEmail}&phone=${data[0].phone}&trandingName=${data[0].tradingName}`,
                solo: true,
            });
        },
    },
    async created() {
        this.setSubscriptionHeader();
        this.setCountNotificationUnread();
    },
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 1280;
        });
        vue.isMobile = window.innerWidth <= 1280;
    },
    computed: {
        ...mapState('user', ['supplierData', 'userNotification']),
        canBuyQuotationCreditCard() {
            return this.supplierData.canBuyQuotationCreditCard;
        },
        coins() {
            return this.supplierData.coins;
        },
        bonus() {
            return this.supplierData.bonus;
        },
        supplierName() {
            return this.supplierData.supplierName;
        },
        planType() {
            return this.supplierData.planType;
        },
        useCreditCardCountdown() {
            return this.supplierData.useCreditCardCountdown;
        },
        count() {
            return this.userNotification.countNotification;
        },
    },
};
</script>

<style></style>
